import { Select, styled, TextField } from "@mui/material";
import { ErrorMessage, Field, useFormikContext } from "formik";
const CustomSelect = styled(Select)(({ theme }) => ({
  ".MuiSelect-select": {
    color: "#3C3C3C !important", // Change the text color here
  },
}));

// component hould be render inside formik provider
/* eslint-disable react/prop-types */
const FormSelectInput = ({ label, ...props }) => {
  const formik = useFormikContext();
  return (
    <div className="flex flex-col mr-4 mb-4 min-w-[200px] ">
      <label
        className="m-1 text-md font-[500] text-[#0C1421]"
        htmlFor={props.name}
      >
        {label}
      </label>
      <Field name={props.name}>
        {({ field, meta }) => {
          const hasError = meta.touched ? meta.error : false;
          return (
            <CustomSelect
              sx={{ color: "#3C3C3C" }}
              placeholder={props.placeholder || label}
              error={hasError}
              onChange={(value) => {
                formik?.setFieldValue(props.name, value.target.value);
              }}
              value={formik?.values[props.name] || ""}
              {...field}
            >
              {props.children}
            </CustomSelect>
          );
        }}
      </Field>
      <ErrorMessage
        name={props.name}
        component="div"
        className="text-red-500"
      />
    </div>
  );
};
export default FormSelectInput;
